(function () {
    window.js = window.js || {};
    js.authorProfile = (function () {
        /**
         * Initialize
         * Initialization for current component
         * @param {object} domElm - current feature element
         */
        function initialize(domElm) {
            var self = this;
            this.elem = domElm;
            this.tabs = this.elem.querySelectorAll('.author-profile__tabs-item');

            for (var i = 0; this.tabs.length > i; i++) {
                self.tabs[i].addEventListener('click', onTabClick);
            }
        }

        /**
         * onTabClick
         * Handler for clicking on a tabItem
         * @type event
         * @param {object} e - event
         */
        function onTabClick(e) {
            e.preventDefault();

            var self = this,
                elem = e.target,
                isChecked = elem.classList.contains('is-active'),
                target = document.querySelector(elem.dataset.target),
                targetInner = target.children[0];

            var getSibligns = function (element) {
                var siblings = [];
                var sibling = element.parentNode.firstChild;
                var skipMe = element; 
                for (; sibling; sibling = sibling.nextSibling)
                    if (sibling.nodeType == 1 && sibling != elem)
                        siblings.push(sibling);
                return siblings;
            }
			 
            if (isChecked) { // Close
                elem.classList.remove('is-active');

                target.removeAttribute('style');
                target.classList.remove('is-active');
            } else { // Open
                var elemSiblings = getSibligns(elem);

                // Reset siblings (trigger)
                for (var x = 0; elemSiblings.length > x; x++) {
                    elemSiblings[x].classList.remove('is-active');

                    var area = document.querySelector(elemSiblings[x].dataset.target);
                    area.removeAttribute('style');
                    area.classList.remove('is-active');
                }
                
                elem.classList.add('is-active');
                
                var itemStyle = window.getComputedStyle(targetInner, null),
                    itemHeight = itemStyle.getPropertyValue('height');
                
                // Set height on target
                target.style.maxHeight = itemHeight;

                // Set as active
                target.classList.add('is-active');
            }
        }
        
        return {
            initialize: initialize
        };
    })();
})();